/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-30 17:14:56
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-17 09:17:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelVersionProducts/index.tsx
 */
import { Spin } from 'antd';
import React from 'react';

import { useHistory, useParams } from 'react-router';

import SalesChannelSelection from '@/src/constrains/SalesChannelSelection';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';

import { NoDataPage } from '@/src/components';
import { Breadcrumb } from '@/src/components/Antd';
import { ProductList } from '../Components';

import useService from './service';

import { useI18n } from 'src/hooks/useRouterChange';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
// import { EnumLinkProductType1 } from 'src/types/common/salesChannelProduct';

import styles from './style.module.less';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';

const permissions = (saleChannelUuid) => {
  const canViewListing = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.view_all_products_listing_page,
      }),
    ],
  });
  const canViewDetails = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.view_product_details_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.delete_product,
      }),
    ],
  });
  return { canViewListing, canViewDetails, canCreate, canDelete };
};
const duplicateProps = {
  productTypes: [],
  // productTypes: [
  //   EnumLinkProductType1.SinglePhysical,
  //   EnumLinkProductType1.SingleService,
  // ],
};
const customerConvertQuery = (filter) => {
  const re: any = duplicateProps;
  if (filter.tags) {
    if (filter.tags.length >= 0) {
      re.tags = filter.tags.map((i) => {
        const { value } = i;
        return { uuid: value };
      });
    }
  }
  if (filter.alias) {
    if (filter.alias.length > 0) {
      re.alias = filter.alias[0].value == 'alias-1' ? true : false;
    }
  }
  if (filter.visible) {
    if (filter.visible.length > 0) {
      re.visible = filter.visible[0].value == 'visible-1' ? true : false;
    }
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};

function SalesChannelVersionProducts() {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const params = useParams<any>();

  const { uuid } = params;

  const userPermissions = permissions(uuid);

  const {
    hasBeenConfiged,
    loading,
    currency,
    salesChannelProductInfo,
    tags,
    total,
    products,
    visible,
    productVisible,
    salesChannelSelected,
    handleChangeVisiblity,
    handleSearchProducts,
    runDuplicate,
    handleDeleteProducts,
    setVisible,
    setProductVisible,
    setSalesChannelSelected,
    decimalPosition,
  } = useService(uuid);

  const addButtonMenu = [
    {
      key: 1,
      name: getI18n('salesChannelProductList.index.createNewProduct'),
      description: getI18n(
        'salesChannelProductList.index.createNewProductDesc',
      ),
      type: getI18n('general.linkModule.Modal.add'),
    },
    {
      key: 2,
      name: getI18n('salesChannelProductList.index.duplicateFromOtherProducts'),
      description: getI18n(
        'salesChannelProductList.index.duplicateFromOtherProductsDesc',
      ),
      type: getI18n('general.duplicate'),
    },
  ];
  const handleLinkToProductPage = () => {
    history.push(
      `/salesChannel/products/link/${uuid}/null?name=${salesChannelProductInfo.salesChannelName}`,
    );
  };

  const handleNavigateToProductPage = (record: any) => {
    if (!record.child) {
      history.push(`/salesChannel/products/link/${uuid}/${record.uuid}`);
    }
  };

  const onOk = (uuids) => {
    setSalesChannelSelected(uuids);
    setProductVisible(true);
    setVisible(false);
    // onChange(products);
  };

  //点击新增按钮触发的下拉菜单
  const addButtonOverlay = (
    <div className={styles.addButtonOverlay}>
      <div className={styles.addButtonTitle}>
        {getI18n('general.addProducts')}
      </div>
      <div className={styles.addButtonAll}>
        {addButtonMenu.map((list) => (
          <div
            key={list.key}
            className={styles.addButtonList}
            onClick={() =>
              list.type === getI18n('general.linkModule.Modal.add')
                ? handleLinkToProductPage()
                : setVisible(true)
            }>
            <p className={styles.addButtonLinkTitle}>{list.name}</p>
            <p className={styles.addButtonLinkDescription}>
              {list.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );

  const onCancel = () => {
    setVisible(false);
    setSalesChannelSelected([]);
  };

  const handleOnCancel = () => {
    setVisible(true);
    setVisible(false);
    setProductVisible(false);
  };

  const handleOnOk = (products) => {
    const productUuids = products.map((item) => item.uuid);
    runDuplicate(uuid, productUuids);
  };

  return (
    <div className={styles.container}>
      {visible && (
        <SalesChannelSelection
          visible={visible}
          onCancel={onCancel}
          onOk={onOk}
          selectedItems={salesChannelSelected || []}
        />
      )}
      {productVisible && (
        <ProductSelection
          onCancel={handleOnCancel}
          visible={productVisible}
          canSelectChildren={false}
          salesChannelUuid={salesChannelSelected[0]}
          okText={getI18n('general.duplicate')}
          cancelText={getI18n('general.back')}
          onOk={handleOnOk}
          customQueryProps={{ customerConvertQuery }}
          initialSearchProps={duplicateProps}
          pageSize={60}
          showPagination={true}
        />
      )}
      <div className={styles.breadcrumb}>
        <Breadcrumb
          className={styles.breadcrumb}
          breadcrumbData={salesChannelProductInfo.breadcrumb}
        />
      </div>
      <div className={styles.content}>
        <Spin spinning={loading}>
          {Array.isArray(products) &&
            (!hasBeenConfiged ? (
              <NoDataPage
                title={getI18n('salesChannelProductList.index.selectproducts')}
                introduce={getI18n(
                  'salesChannelProductList.index.selectproductsintroduce',
                )}
                buttonTitle={
                  userPermissions.canCreate && getI18n('general.addProducts')
                }
                addButtonOverlay={addButtonOverlay}
                onClick={handleLinkToProductPage}
              />
            ) : (
              <ProductList
                salesChannelUuid={uuid}
                currency={currency}
                tagList={tags}
                total={total}
                products={products}
                addButtonOverlay={addButtonOverlay}
                userPermissions={userPermissions}
                onSearch={handleSearchProducts}
                onDelete={handleDeleteProducts}
                onChangeVisiblity={handleChangeVisiblity}
                onClickCreate={handleLinkToProductPage}
                onNavigateToProductDetail={handleNavigateToProductPage}
                decimalPosition={decimalPosition}
              />
            ))}
        </Spin>
      </div>
    </div>
  );
}

export default SalesChannelModeAccessControlHOC(SalesChannelVersionProducts);
